// extracted by mini-css-extract-plugin
export default {"root":"TariffListCard__root--1kfj2","recommended":"TariffListCard__recommended--2m6kJ"};